import { Injectable } from "@nestjs/common";
import { DataSource, Repository } from "typeorm";
import { PPMDataEntity } from "../entites/ppm.entity";
import { BomCreationFiltersReq, PoDataForBomGenerationModel, UpdateBomITemNoFilters } from "@project-management-system/shared-models";
import { PPMFileUploadEntity } from "../entites/ppm-file-upload.entity";
import { ApaSizeMatrixEntity } from "../../po-bom/entittes/apa-size-matrix-entitys";


@Injectable()
export class PPMDataRepository extends Repository<PPMDataEntity> {

    constructor(private dataSource: DataSource) {
        super(PPMDataEntity, dataSource.createEntityManager());

    }

    async getPPMDataForBOM(fileId: number): Promise<any[]> {
        const query = this.createQueryBuilder('ppm')
            .select('*')
            .where('file_id = :fileId', { fileId })
            .orderBy(`po_number`, 'ASC')
        return await query.getRawMany();
    }

    async getBomCreationData(req: BomCreationFiltersReq): Promise<any[]> {


        const distinctSizesQuery = await this
            .createQueryBuilder('pd')
            .select('DISTINCT pd.size_description', 'size')
            .andWhere(`pd.size_qty > 0`)
        if (req?.style !== undefined) {
            distinctSizesQuery.andWhere(`pd.style_number IN (:...style)`, { style: req.style })
        }
        if (req?.geoCode !== undefined) {
            console.log(req.geoCode, 'geo code')
            distinctSizesQuery.andWhere(`pd.geo_code IN (:...geoCode)`, { geoCode: req.geoCode })
        }
        if (req?.item !== undefined) {
            // const items = req.item.split(',').map(item => item.trim());
            distinctSizesQuery.andWhere(`LEFT(pd.bom_item, 4) IN (:...items)`, { items: req.item });
        }
        if (req.fromDate !== undefined) {
            distinctSizesQuery.andWhere(`pd.document_date BETWEEN '${req.fromDate}' AND '${req.toDate}'`)
        }
        if (req.poLine !== undefined) {
            distinctSizesQuery.andWhere(`pd.po_and_line IN (:...poLine)`, { poLine: req.poLine })
        }
        if (req?.planningSeasonCode !== undefined) {
            distinctSizesQuery.andWhere(`planning_season_code ='${req.planningSeasonCode}'`)
        }
        if (req?.planningSeasonYear !== undefined) {
            distinctSizesQuery.andWhere(`planning_season_year ='${req.planningSeasonYear}'`)
        }
        if (req?.productCode !== undefined) {
            distinctSizesQuery.andWhere(`product_code ='${req.productCode}'`)
        }
        if (req?.fileId !== undefined) {
            distinctSizesQuery.andWhere(`file_id ='${req.fileId}'`)
        }


        const distinctSizes = await distinctSizesQuery.getRawMany();
        console.log(distinctSizes, 'distinct sizes')

        // Generate conditional aggregations for each distinct size
        const columnsQuery = distinctSizes
            .map(size => {
                const sizeColumnName = size.size.replace(/`/g, '``');
                return `SUM(CASE WHEN pd.size_description = '${size.size}' THEN pd.size_qty ELSE 0 END) AS '${sizeColumnName}'`;
            })
            .join(', ');
        console.log(distinctSizes)
        console.log(columnsQuery)
        const query = this.createQueryBuilder('pd')
            .select(`po_number as poNumber , po_line_item_number as poLineItemNumber ,po_and_line as poLine,LEFT(bom_item, 4) as item, style_number as styleNumber , planning_season_code as planningSeasonCode , planning_season_year as planningSeasonYear, geo_code as geoCode, gender_age_desc as genderAgeDesc,
            destination_country as destinationCountry,plant,product_code as productCode,color_desc as colorDesc,total_item_qty as totalSizeQty,ogac,REPLACE(REPLACE(shipping_type, ' ', '_'), '_', ' ') AS shippingType,document_date as documentDate , item_vas_text as itemVasText,${columnsQuery},file_id AS uploadedFileId`)
        if (req?.fileId !== undefined) {
            query.where(`file_id ='${req.fileId}'`)
        }
        if (req?.style !== undefined) {
            query.andWhere(`pd.style_number IN (:...style)`, { style: req.style })
        }
        if (req?.geoCode !== undefined) {
            query.andWhere(`pd.geo_code IN (:...geoCode)`, { geoCode: req.geoCode })
        }
        if (req?.item !== undefined) {
            // const items = req.item.split(',').map(item => item.trim());
            query.andWhere(`LEFT(pd.bom_item, 4) IN (:...items)`, { items: req.item });
        }
        if (req.fromDate !== undefined) {
            query.andWhere(`DATE(pd.document_date) BETWEEN DATE('${req.fromDate}') AND DATE('${req.toDate}')`)
        }
        if (req.poLine !== undefined) {
            query.andWhere(`pd.po_and_line IN (:...poLine)`, { poLine: req.poLine })
        }
        if (req?.planningSeasonCode !== undefined) {
            query.andWhere(`planning_season_code ='${req.planningSeasonCode}'`)
        }
        if (req?.planningSeasonYear !== undefined) {
            query.andWhere(`planning_season_year ='${req.planningSeasonYear}'`)
        }
        if (req?.productCode !== undefined) {
            query.andWhere(`product_code ='${req.productCode}'`)
        }

        //  .groupBy(`po_and_line`)
        query.groupBy('pd.po_number,pd.po_line_item_number',)
        query.orderBy('pd.po_number,pd.po_line_item_number')
        // query.skip(pageNumber * pageSize)
        // query.take(pageSize)
        return await query.getRawMany();
    }

    async getPoDataForBomGeneration(req: { poLine: string[], fileId: number }): Promise<PoDataForBomGenerationModel[]> {
        const query = await this.createQueryBuilder('pd')
            .select(`id,po_number as poNumber,po_line_item_number as poLineNo,style_number as styleNumber,color_desc as color,destination_country as destination,geo_code as geoCode,plant,planning_season_code as season,planning_season_year as year,size_qty as qty,size_description as size,gender_age_desc as gender,bom_item as bomItem,shipping_type as shippingType,item_vas_text as itemVasText,product_Name as productName`)
            .where(`po_and_line IN (:...poLine)`, { poLine: req.poLine })
            .andWhere(`file_id = ${req.fileId}`)
        const data = await query.getRawMany()
        const mappedResult: PoDataForBomGenerationModel[] = data.map(item => ({
            id: item.id,
            poNumber: item.poNumber,
            poLineNo: item.poLineNo,
            styleNumber: item.styleNumber,
            color: item.color,
            destination: item.destination,
            geoCode: item.geoCode,
            plant: item.plant,
            season: item.season,
            year: item.year,
            qty: item.qty,
            size: item.size,
            gender: item.gender,
            item: item.bomItem,
            shippingType: item.shippingType,
            itemVasText: item.itemVasText,
            productName: item.productName
        }));

        return mappedResult

    }

    async getAllDpomDataForBom(req?: UpdateBomITemNoFilters): Promise<any[]> {
        const query = await this.createQueryBuilder('pd')
            .select(`id AS dpom_id,po_and_line,last_modified_date,item,factory,
        po_number,po_line_item_number,dpom_item_line_status,style_number,product_code,color_desc,
        customer_order,plan_no,category_code,category_desc,
        vendor_code,gcc_focus_code,gcc_focus_desc,gender_age_code,gender_age_desc,destination_country_code,
        destination_country,plant,plant_name,direct_ship_so_item_no,
        customer_po,planning_season_code,planning_season_year ,bom_item,
         pcd, mrgac,ogac,truck_out_date,
         total_item_qty,actual_shipped_qty,
         legal_po_price,co_price,pcd,ship_to_address_legal_po,
         ship_to_address_dia,
         actual_unit,allocated_quantity
        ,size_description,size_qty,trading_co_po_no,hanger,legal_po_qty,geo_code, co_line_status,REPLACE(REPLACE(shipping_type, ' ', '_'), '_', ' ') AS shippingType,document_date`)
            .where(`doc_type_code != 'ZP26' AND dpom_item_line_status != 'Closed' AND dpom_item_line_status != 'Cancelled'`)
        if (req.styleNo !== undefined) {
            query.andWhere(`style_number IN (:...styleNo)`, { styleNo: req.styleNo })
        }
        if (req.planningSeasonCode !== undefined) {
            query.andWhere(`planning_season_code ='${req.planningSeasonCode}'`)
        }
        if (req.planningSeasonYear !== undefined) {
            query.andWhere(`planning_season_year ='${req.planningSeasonYear}'`)
        }
        if (req.fromDate !== undefined) {
            query.andWhere(`pd.document_date BETWEEN '${req.fromDate}' AND '${req.toDate}'`)
        }
        if (req.itemStatus !== undefined) {
            if (req.itemStatus === "null") {
                query.andWhere(`bom_item IS NULL`);
            }
            if (req.itemStatus === "Updated") {
                query.andWhere(`bom_item IS NOT NULL`);
            }
        }
        query.groupBy(`po_number , po_line_item_number`)
        return await query.getRawMany();
    }

    async getStylesOtherThanAPAMatrix(): Promise<any[]> {
        const query = this.createQueryBuilder('pd')
            .select('pd.id ,pd.style_number AS style')
            .leftJoin(ApaSizeMatrixEntity, 'aps', 'aps.style_number = pd.style_number')
            .where('aps.style_number IS NULL')
            .groupBy('pd.style_number')
        return await query.getRawMany();
    }

}

